/* eslint-disable react/prop-types */
import { getCitiesOrDistricts } from '@api/collection'
import FieldAutocomplete2 from '@components/CustomFields/FieldAutocomplete2'
import FieldText from '@components/CustomFields/FieldText'
import { makeStyles, InputLabel, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import getDomain from '@config/domain'

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    width: '90%',
    flexDirection: 'column',
    marginTop: 52,
    height: '100%',
    paddingBottom: 200,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
    },
  },
  txReceiver: {
    fontWeight: 'bold',
    fontSize: 20,
  },
  inputLabel: {
    marginBottom: theme.spacing(0.5),
    fontSize: 12,
  },
  parentWarn: {
    borderRadius: 10,
    padding: 10,
    backgroundColor: '#F5F5F5',
    margin: '10px 0px',
  },
  textWarn: {
    fontSize: 12,
    color: '#9E9E9E',
  },
}))

const AffiliateForm2 = (props) => {
  const { register, isSubmitting, watch } = props
  const classes = useStyles()
  const affCode = watch('affiliate_code')
  useEffect(() => {
    const checkAffiliateCode = setTimeout(() => {
      // Send function after timeout
    }, 1000)

    return () => clearTimeout(checkAffiliateCode)
  }, [affCode])

  return (
    <div className={classes.form}>
      <FieldText
        name="address"
        label="Alamat"
        register={register}
        disabled={isSubmitting}
        watch={watch}
        {...props}
      />
      <FieldAutocomplete2
        name="district"
        label="Kota / Kecamatan"
        register={register}
        api={getCitiesOrDistricts}
        placeholder="Cari Kota / Kecamatan..."
        getOptionValue={(option, value) => option.id === value.id}
        getOptionLabel={(value) => value?.formated_name}
        searchParams="name"
        {...props}
      />
      <FieldText
        name="affiliate_code"
        label="Kode Affiliate"
        register={register}
        disabled={isSubmitting}
        watch={watch}
        style={{ marginTop: 0, marginBottom: 0 }}
        {...props}
      />
      <div className={classes.parentWarn}>
        <Typography className={classes.textWarn}>
          {' '}
          Diisi kode unik tanpa spasi (bisa berupa inisial nama atau panggilan)
          untuk menandakan suatu pesanan berasal dari link Anda
        </Typography>
      </div>
      {watch('affiliate_code') && (
        <div>
          <InputLabel className={classes.inputLabel}>
            Preview Kode Affiliate
          </InputLabel>
          <Typography>
            {`https:${getDomain()}?aff=${watch('affiliate_code')}`}
          </Typography>
        </div>
      )}
    </div>
  )
}
export default AffiliateForm2
